<nz-breadcrumb *ngIf="data && searchType == 'sim'">
	<nz-breadcrumb-item>
		<a [routerLink]="['/home']">Home</a>
	</nz-breadcrumb-item>
	<nz-breadcrumb-item>
		<a [routerLink]="['/subscriber/sim-search']">Sim Search</a>
	</nz-breadcrumb-item>
	<nz-breadcrumb-item>
		<a [routerLink]="['/subscriber/sim-view',data.person.id, data.msisdns[0].id]">View Sim</a>
	</nz-breadcrumb-item>
	<nz-breadcrumb-item>View Subscriber</nz-breadcrumb-item>
</nz-breadcrumb>
<nz-breadcrumb *ngIf="data && searchType == 'document'">
	<nz-breadcrumb-item>
		<a [routerLink]="['/home']">Home</a>
	</nz-breadcrumb-item>
	<nz-breadcrumb-item>
		<a [routerLink]="['/subscriber/document-search']">Sim Document</a>
	</nz-breadcrumb-item>
	<nz-breadcrumb-item>
		<a [routerLink]="['/subscriber/document-view',searchRef]">View Document</a>
	</nz-breadcrumb-item>
	<nz-breadcrumb-item>View Subscriber</nz-breadcrumb-item>
</nz-breadcrumb>

<div class="row" *ngIf="data">
	<div class="col">
		<div class="card"  #contentToPrint>
			<div class="card-header text-bg-success">
				{{getDocumentGivenNames(data.primary)}} {{data.primary.lastName}}
				<div class="float-end">
					<div class="d-flex justify-content-end">
						<app-pdf-export-button *ngIf="contentToPrintElement" [resource]="contentToPrintElement" [name]="'Subscriber_' + data.person.id" [heading]="'Subscriber: ' + data.person.id" [alignRight]="false"></app-pdf-export-button>
					</div>
					<a *ngIf="searchType == 'sim'" class="ms-2 float-end btn btn-sm btn-outline-light" [routerLink]="['/subscriber/sim-search']"> Go Back</a>
					<a *ngIf="searchType == 'document'" class="ms-2 float-end btn btn-sm btn-outline-light" [routerLink]="['/subscriber/document-search']"> Go Back</a>
				</div>
			</div>
		    <nz-tabset [nzTabPosition]="'top'" nzType="card" nzSize="small"  [nzSelectedIndex]="selectedTabIndex" (nzSelectedIndexChange)="selectedTabIndex = $event">
				<nz-tab [nzTitle]="'Overview'" class="m-0">
					<div class="card-body bg-secondary-subtle">
						<h2>All Documents</h2>
						<div class="row mt-1">
							<div class="col">
								<table class="table">
									<thead class="table-success">
										<tr>
											<th>Date Registered</th>
											<th>Document Type</th>
											<th>Document Number</th>
											<th>ID Number</th>
											<th>Given Names</th>
											<th>Last Name</th>
											<th>Gender</th>
											<th>Date of Birth</th>
											<th>Date of Issue</th>
											<th>Date of Expiry</th>
											<th>Verification Status</th>
											<th>Used by other people</th>
										</tr>
									</thead>
									<tbody>
										<tr *ngFor="let document of data.documents">
											<td>{{document.createdAt | date}}</td>
											<td>{{document.documentType}}</td>
											<td>{{document.documentNumber}}</td>
											<td>{{document.idNumber}}</td>
											<td>{{getDocumentGivenNames(document)}}</td>
											<td>{{document.lastName}}</td>
											<td>{{document.gender}}</td>
											<td>{{document.dateOfBirth | date}}</td>
											<td>{{document.dateOfIssue | date}}</td>
											<td>{{document.dateOfExpiry | date}}</td>
											<td>{{document.verificationStatus}}</td>
											<td>{{document.duplicates}}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
					<div class="card-body bg-secondary-subtle">
						<h2>Minors</h2>
						<p *ngIf="data.minors.length == 0">No minors registered</p>
						<div class="row mt-1" *ngIf="data.minors.length > 0">
							<div class="col">
								<table class="table">
									<thead class="table-success">
										<tr>
											<th>Registered Date</th>
											<th>Given Names</th>
											<th>Last Name</th>
											<th>Gender</th>
											<th>Date Of Birth</th>
										</tr>
									</thead>
									<tbody>
										<tr *ngFor="let minor of data.minors">
											<td>{{minor.createdAt | date}}</td>
											<td>{{getMinorGivenNames(minor)}}</td>
											<td>{{minor.lastName}}</td>
											<td>{{minor.gender}}</td>
											<td>{{minor.dateOfBirth| date}}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
					<div class="card-body bg-secondary-subtle">
						<h2>Sim Cards</h2>
						<div class="row mt-1">
							<div class="col">
								<table class="table">
									<thead class="table-success">
										<tr>
											<th>ICCID</th>
											<th>Sim Serial</th>
											<th>MSISDN</th>
											<th>Status</th>
											<th>Registration Date</th>
											<th>End Date</th>
											<th>Partner</th>
											<th>For Minor</th>
											<th>Uploaded By</th>
											<th>Uploaded Time</th>
											<th>Verification</th>
										</tr>
									</thead>
									<tbody>
										<tr *ngFor="let msisdn of data.msisdns">
											<td>{{msisdn.iccid}}</td>
											<td>{{msisdn.simSerial}}</td>
											<td>{{msisdn.internationalMsisdn}}</td>
											<td>
												<span *ngIf="msisdn.simStatus == 'Active'" class="text-success">Active</span>
												<span *ngIf="msisdn.simStatus == 'Swapped'" class="text-warning">Swapped</span>
												<span *ngIf="msisdn.simStatus == 'Transferred'" class="text-warning">Transferred</span>
												<span *ngIf="msisdn.simStatus == 'Terminated'" class="text-warning">Terminated</span>
											</td>
											<td>{{msisdn.startDate | date}}</td>
											<td>{{(msisdn.endDate | date)??'-'}}</td>
											<td>{{msisdn.partner.name}}</td>
											<td>{{findMinor(msisdn)?.firstName??'-'}}</td>
											<td>{{msisdn.uploadedBy?.username??'FTP'}}</td>
											<td>{{msisdn.uploadedAt | date }}</td>
											<td>
												<fa-icon [icon]="faCheck" *ngIf="msisdn.documentStatus == 'Perfect'" class="text-success"></fa-icon>
												<fa-icon [icon]="faCheck" *ngIf="msisdn.documentStatus == 'Match'" class="text-success"></fa-icon>
												<fa-icon [icon]="faCheck" *ngIf="msisdn.documentStatus == 'Acceptable'" class="text-success"></fa-icon>
												<fa-icon [icon]="faXmark" *ngIf="msisdn.documentStatus == 'Failed'" class="text-danger"></fa-icon>
												<fa-icon [icon]="faNotdef" *ngIf="msisdn.documentStatus == 'NotFound'" class="text-warning"></fa-icon>
												<fa-icon [icon]="faHourglass" *ngIf="msisdn.documentStatus == 'Skipped'" class="text-secondary"></fa-icon>
												<fa-icon [icon]="faHourglass" *ngIf="msisdn.documentStatus == 'Pending'" class="text-secondary"></fa-icon>
												{{msisdn.documentStatus}}
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
					<div class="card-body bg-secondary-subtle"  *hasPermission="['SubscriberCdrView','SubscriberCdrUpload']">
						<h2>CDR's</h2>
						<div class="row"  *hasPermission="['SubscriberCdrUpload']">
							<div class="col">
								<nz-upload
									nzType="drag"
									[nzMultiple]="false"
									[nzCustomRequest]="customUploadCdr"
									[nzShowUploadList]="false"
									[nzBeforeUpload]="beforeUploadCdr"
									nzFileType="text/csv"
									nzAccept=".csv">
									<p class="ant-upload-drag-icon">
										<i nz-icon nzType="inbox" ></i>
									</p>
									<p class="ant-upload-text">Click or drag file to this area to upload</p>
									<p class="ant-upload-hint">Support for a csv upload only.</p>
								</nz-upload>
							</div>
						</div>
						<div class="row mt-1"  *hasPermission="['SubscriberCdrView']">
							<div class="col">
								<table class="table">
									<thead class="table-success">
										<tr>
											<th>Id</th>
											<th>Created At</th>
											<th>Record Id</th>
											<th>Type</th>
											<th>Called Number</th>
											<th>Website</th>
											<th>Start Time</th>
											<th>End Time</th>
											<th>Duration Seconds</th>
											<th>Data Volume Kb</th>
											<th>Cell Id</th>
											<th>Call Direction</th>
											<th>Record Result</th>
										</tr>
									</thead>
									<tbody>
										<tr *ngFor="let cdr of data.cdrs">
											<td>{{cdr.id}}</td>
											<td>{{cdr.createdAt}}</td>
											<td>{{cdr.recordId}}</td>
											<td>{{cdr.type}}</td>
											<td>{{cdr.calledNumber}}</td>
											<td>{{cdr.website}}</td>
											<td>{{cdr.startTime}}</td>
											<td>{{cdr.endTime}}</td>
											<td>{{cdr.durationSeconds}}</td>
											<td>{{cdr.dataVolumeKb}}</td>
											<td>{{cdr.cellId}}</td>
											<td>{{cdr.callDirection}}</td>
											<td>{{cdr.recordResult}}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</nz-tab>
				<nz-tab nzTitle="Images" *hasPermission="['AuditViewList']">


					<div class="card-body bg-secondary-subtle">
						<div *hasPermission="['SubscriberCdrUpload']">

							<!-- Portrait -->
							 <h4 class="mb-2">Portrait</h4>
							<div class="row mb-3 align-items-center">
								<div class="col-auto">
									<nz-upload
									[nzCustomRequest]="customUploadPortrait"
									[nzBeforeUpload]="beforeUploadPortrait"
									(nzChange)="handleChangePortrait($event)"
									[nzShowUploadList]="false">
									<button class="btn btn-primary">
										<i nz-icon nzType="upload"></i>
										Upload
									</button>
									</nz-upload>
								</div>
								<div class="col">
									<img *ngIf="imagePreviewPortrait" [src]="imagePreviewPortrait" alt="Portrait preview" class="img-preview"/>
								</div>
							</div>
							<hr/>

							<!-- Document Front -->
							<h4 class="mb-2">Document Front</h4>
							<div class="row mb-3 align-items-center">
							<div class="col-auto">
								<nz-upload
								[nzCustomRequest]="customUploadDocumentFront"
								[nzBeforeUpload]="beforeUploadDocumentFront"
								(nzChange)="handleChangeDocumentFront($event)"
								[nzShowUploadList]="false">
								<button class="btn btn-primary">
									<i nz-icon nzType="upload"></i>
									Upload
								</button>
								</nz-upload>
							</div>
							<div class="col">
								<img *ngIf="imagePreviewDocumentFront" [src]="imagePreviewDocumentFront" alt="Document Front preview" class="img-preview" />
							</div>
							</div>
							<hr/>

							<!-- Document Back -->
							<h4 class="mb-2">Document Back</h4>
							<div class="row mb-3 align-items-center">
							<div class="col-auto">
								<nz-upload
								[nzCustomRequest]="customUploadDocumentBack"
								[nzBeforeUpload]="beforeUploadDocumentBack"
								(nzChange)="handleChangeDocumentBack($event)"
								[nzShowUploadList]="false">
								<button class="btn btn-primary">
									<i nz-icon nzType="upload"></i>
									Upload
								</button>
								</nz-upload>
							</div>
							<div class="col">
								<img *ngIf="imagePreviewDocumentBack" [src]="imagePreviewDocumentBack" alt="Document Back preview" class="img-preview" />
							</div>
							</div>
							<hr/>

							<!-- Proof Of Address -->
							<h4 class="mb-2">Proof Of Address</h4>
							<div class="row mb-3 align-items-center">
							<div class="col-auto">
								<nz-upload
								[nzCustomRequest]="customUploadProofOfAddress"
								[nzBeforeUpload]="beforeUploadProofOfAddress"
								(nzChange)="handleChangeProofOfAddress($event)"
								[nzShowUploadList]="false">
								<button class="btn btn-primary">
									<i nz-icon nzType="upload"></i>
									Upload
								</button>
								</nz-upload>
							</div>
							<div class="col">
								<img *ngIf="imagePreviewProofOfAddress" [src]="imagePreviewProofOfAddress" alt="Proof Of Address preview" class="img-preview" />
							</div>
							</div>

						</div>
					</div>




				</nz-tab>
				<nz-tab nzTitle="Audit: View" *hasPermission="['AuditViewList']">
					<app-audit-table-views *ngIf="selectedTabIndex == 2" [fetchAudits]="fetchAudits"></app-audit-table-views>
				</nz-tab>

				<nz-tab *ngFor="let item of documentWithVerificationList; let idx = index" [nzTitle]="item.document.documentType +': '+ item.document.documentNumber">
					<h3>Comparing Registered Document with Government Records</h3>
					<div class="row">
						<div class="col">
							<div class="alert alert-info" *ngIf="item.document.verificationStatus == 'Pending'">
								<ng-container *ngIf="item.isVerifying == true">
									Verifing document...
								</ng-container>
								<ng-container *ngIf="item.isVerifying == false">
									Document has not been verified yet
									<br>
									Click <button class="btn btn-sm btn-link m-0 p-0" (click)="doVerify(item)">here</button> to verify now.
								</ng-container>
							</div>
							<div class="alert alert-danger" *ngIf="item.document.verificationStatus == 'NotFound'">
								No government records exist
							</div>
							<div class="alert alert-danger" *ngIf="item.document.verificationStatus == 'Failed'">
								Document does not match Government Records
							</div>

							<div class="alert alert-warning"  *ngIf="item.document.duplicates! > 0">
								There appear to be other people registered with a {{item.document.documentType}} matching this documents number "<small>{{item.document.documentNumber}}</small>".
								<br>
								Click <a class="btn btn-sm btn-link m-0 p-0">here</a> to view them.
							</div>
						</div>
					</div>
					<table class="table mt-3">
						<thead>
							<tr>
								<th>Field</th>
								<th>Registered Details</th>
								<th>Government Details</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Document Type</td>
								<td>{{item.document.documentType}}</td>
								<td *ngIf="item.governmentRecord">{{item.governmentRecord.documentType}}</td>
								<td *ngIf="!item.governmentRecord">{{item.document.verificationStatus}}</td>
							</tr>
							<tr>
								<td>Document Number</td>
								<td>{{item.document.documentNumber}}</td>
								<td *ngIf="item.governmentRecord">{{item.governmentRecord.documentNumber}}</td>
								<td *ngIf="!item.governmentRecord">{{item.document.verificationStatus}}</td>
							</tr>
							<tr>
								<td>Id Number</td>
								<td>{{item.document.idNumber}}</td>
								<td *ngIf="item.governmentRecord">{{item.governmentRecord.idNumber}}</td>
								<td *ngIf="!item.governmentRecord">{{item.document.verificationStatus}}</td>
							</tr>
							<tr>
								<td>First Name</td>
								<td>{{item.document.firstName}}</td>
								<td *ngIf="item.governmentRecord">{{item.governmentRecord.firstName}}</td>
								<td *ngIf="!item.governmentRecord">{{item.document.verificationStatus}}</td>
							</tr>
							<tr>
								<td>Second Name</td>
								<td>{{item.document.secondName}}</td>
								<td>-</td>
							</tr>
							<tr>
								<td>Other Names</td>
								<td>{{item.document.otherNames}}</td>
								<td *ngIf="item.governmentRecord">{{item.governmentRecord.otherName}}</td>
								<td *ngIf="!item.governmentRecord">{{item.document.verificationStatus}}</td>
							</tr>
							<tr>
								<td>Last Name</td>
								<td>{{item.document.lastName}}</td>
								<td *ngIf="item.governmentRecord">{{item.governmentRecord.surname}}</td>
								<td *ngIf="!item.governmentRecord">{{item.document.verificationStatus}}</td>
							</tr>
							<tr>
								<td>Gender</td>
								<td>{{item.document.gender}}</td>
								<td *ngIf="item.governmentRecord">{{item.governmentRecord.gender}}</td>
								<td *ngIf="!item.governmentRecord">{{item.document.verificationStatus}}</td>
							</tr>
							<tr>
								<td>Date Of Birth</td>
								<td>{{item.document.dateOfBirth}}</td>
								<td *ngIf="item.governmentRecord">{{item.governmentRecord.dateOfBirth}}</td>
								<td *ngIf="!item.governmentRecord">{{item.document.verificationStatus}}</td>
							</tr>
							<tr>
								<td>Date Of Issue</td>
								<td>{{item.document.dateOfIssue}}</td>
								<td *ngIf="item.governmentRecord">{{item.governmentRecord.dateOfIssue}}</td>
								<td *ngIf="!item.governmentRecord">{{item.document.verificationStatus}}</td>
							</tr>
							<tr>
								<td>Date Of Expiry</td>
								<td>{{item.document.dateOfExpiry}}</td>
								<td *ngIf="item.governmentRecord">{{item.governmentRecord.dateOfExpiry}}</td>
								<td *ngIf="!item.governmentRecord">{{item.document.verificationStatus}}</td>
							</tr>
							<tr>
								<td>Issuing Country</td>
								<td>{{item.document.issuingCountry}}</td>
								<td>-</td>
							</tr>
							<tr>
								<td>Nationality</td>
								<td>{{item.document.nationality}}</td>
								<td>-</td>
							</tr>
							<tr>
								<td>Place Of Birth</td>
								<td>{{item.document.placeOfBirth}}</td>
								<td *ngIf="item.governmentRecord">{{item.governmentRecord.placeOfBirth}}</td>
								<td *ngIf="!item.governmentRecord">{{item.document.verificationStatus}}</td>
							</tr>
							<tr>
								<td>County</td>
								<td>{{item.document.county}}</td>
								<td>-</td>
							</tr>
							<tr>
								<td>Sub County</td>
								<td>{{item.document.subCounty}}</td>
								<td>-</td>
							</tr>
							<tr>
								<td>Division</td>
								<td>{{item.document.division}}</td>
								<td>-</td>
							</tr>
							<tr>
								<td>Location</td>
								<td>{{item.document.location}}</td>
								<td>-</td>
							</tr>
							<tr>
								<td>Sub Location</td>
								<td>{{item.document.subLocation}}</td>
								<td>-</td>
							</tr>
						</tbody>
					</table>
				</nz-tab>
			</nz-tabset>
		</div>
	</div>
</div>
